import { z } from 'zod';

import { entityIdentifierSchema } from './chat-entity';

export const contextRefreshActionSchema = z.enum(['archived', 'created', 'deleted', 'unarchived', 'updated']);

export type ContextRefreshAction = z.infer<typeof contextRefreshActionSchema>;

/** The value of a `cobrainer.context-refresh` event: what the agent changed, once per id. */
export const contextRefreshEventSchema = z.object({
    action: contextRefreshActionSchema,
    entities: z.array(entityIdentifierSchema).min(1),
    id: z.uuid(),
});

export type ContextRefreshEvent = z.infer<typeof contextRefreshEventSchema>;
